import { SxProps } from '@mui/material';

export const getWrapperStyles = (styleOverrides: SxProps, containerWidth: string) => ({
	py: '0.25rem',
	px: { xs: '1.25rem', md: '4rem' },
	width: '100%',
	maxWidth: containerWidth,
	...styleOverrides,
});
